<template>
  <div>
    <div
      v-t="'ADJUST_CALL_PAYMENT'"
      class="ag-grid__overlay-form-box-title"
    />
    
    <div class="p-15">
      <div
        class="clickable m-b-10"
        @click="returnToReviewDetails"
      >
        <i class="fa fa-chevron-left m-r-5" />
        {{ returnToReviewLabel }}
      </div>
      <div>
        <div>
          <div
            v-t="'CONFIRM_CHANGES'"
            class="f-s-16 p-l-15 col-sm-offset-3" 
          />
          <form
            name="callActionConfirmation"
            role="form"
            class="form-horizontal p-t-10 p-b-10"
          >
            <slot />

            <div class="form-group">
              <div class="p-l-15 col-sm-offset-3">
                <button
                  type="button"
                  class="btn btn-primary btn-sm m-t-15"
                  :disabled="pendingBulkCallAdjustmentByLogs"
                  @click.once="confirmForm"
                >
                  {{ $t('CONFIRM')}}
                  <Loader
                    v-if="pendingBulkCallAdjustmentByLogs"
                    custom-class="size-sm"
                  />
                </button>
  
                <button
                  v-t="'CANCEL'"
                  class="btn btn-danger btn-sm m-t-15 m-l-10"
                  @click="cancelForm"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import messages from './locales';
import Loader from '@/core/components/Loader';

export default {
  components: {
    Loader
  },
  props: {
    returnToReviewLabel: {
      type: String,
      default: function() { 
        return this.$t('REVIEW_CHANGES');
      }
    },
    pendingBulkCallAdjustmentByLogs: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    confirmForm() {
      this.$emit('confirmAction');
    },
    cancelForm() {
      this.$emit('cancelForm');
    },
    returnToReviewDetails() {
      this.$emit('returnToReviewDetails');
    }
  },

  i18n: {
    locale: 'en',
    messages
  }
};
</script>

<style>

</style>